import { ReactElement } from 'react'
import { useRouter } from 'next/router'
import { Button } from '@chakra-ui/react'
import useIntl from '~/hooks/useIntl/useIntl'
import { ErrorPageWrapper } from '~/components/ErrorPageWrapper'
import { usePlatformTheme } from '~/context/theme'
import { usePlatformRoutes } from '~/context/partner'

function NotFoundErrorPage(): ReactElement {
  const intl = useIntl()
  const router = useRouter()
  const { themeId } = usePlatformTheme()
  const { createRoutePath } = usePlatformRoutes()

  const redirectToMainPage = () => {
    router.replace(createRoutePath('/'))
  }

  const t = {
    notFoundTitle: intl.formatMessage({
      id: 'not-found-title',
      defaultMessage: '404 error - Page not found',
    }),
    helpText: intl.formatMessage({
      id: 'not-found-help-message',
      defaultMessage:
        "The page you're looking for cannot be found. It may have been renamed or removed.",
    }),
    backToSearch: intl.formatMessage({
      id: 'back-to-search',
      defaultMessage: 'Back to the search',
    }),
  }

  return (
    <ErrorPageWrapper title={t.notFoundTitle} themeId={themeId}>
      <p>{t.helpText}</p>
      <p>
        <Button variant="primary" size="md" onClick={redirectToMainPage}>
          {t.backToSearch}
        </Button>
      </p>
    </ErrorPageWrapper>
  )
}

export default NotFoundErrorPage
